<template>
  <div class="hello">
    <h2>IT勉強会検索</h2>
    <ul>
      <li>
        <a href="/kansai">
          関西
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Top"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue